import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=559f19ce&scoped=true&lang=pug"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=559f19ce&prod&scoped=true&lang=scss"
import style1 from "./notification.vue?vue&type=style&index=1&id=559f19ce&prod&lang=scss"
import style2 from "@ui-common/vue-notification/dist/vue-notification.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f19ce",
  null
  
)

export default component.exports